require('expose-loader?LuckyDip!../../../src/app/sportsbook_components/lucky_dip');
